const openCart = () => {
    document.body.setAttribute('data-cart-modal-open', 'true')
    document.addEventListener('keyup', handleEscape)
}

const closeCart = () => {
    document.body.removeAttribute('data-cart-modal-open')
    document.removeEventListener('keyup', handleEscape)
}

const handleEscape = (event) => {
    if (event.key === 'Escape') closeCart()
}

document.addEventListener('click', (event) => {
    if (event.target.closest('[data-close-cart]')) closeCart()
})

export {
    openCart,
    closeCart
}
